<template>
<div>
  <div class="qaFeedback container">
    <Header v-show="!show" title="销售方质保信息"></Header>

    <div class="info">
      <div class="info-item">
        <div class="title">博世料号：</div>
        <div class="text">{{codeInfo.partNo}}</div>
      </div>

      <div v-if="codeInfo.warrantyStatus===4">
        <div class="info-item">
          <div class="title">保单状态：</div>
          <div class="text">{{getItemStatus(codeInfo.warrantyStatus)}}</div>
        </div>

        <div class="info-item">
          <div class="title">审批状态：</div>
          <div class="text">{{codeInfo.verifyStatus}}</div>
        </div>

        <div class="info-item">
          <div class="title">审批备注：</div>
          <div class="text">{{codeInfo.warrantyHistory[0].verifyRemark}}</div>
        </div>
      </div>

      <div class="info-item">
        <div class="title">产品名称：</div>
        <div class="text">{{codeInfo.partName}}</div>
      </div>
      <div class="info-item">
        <div class="title">车型：</div>
        <div class="text">{{codeInfo.carName}}</div>
      </div>
      <div class="info-item">
        <div class="title">车主手机号：</div>
        <div class="text">{{codeInfo.consumerMobile}}</div>
      </div>
      <div class="info-item">
        <div class="title">安装时里程数：</div>
        <div class="text">{{codeInfo.initMileage}}&nbsp;KM</div>
      </div>
      <div class="info-item">
        <div class="title">销售方信息：</div>
        <div class="text">{{codeInfo.workshopName}} {{codeInfo.workshopAddress}}</div>
      </div>
      <div class="info-item">
        <div class="title">安装时间：</div>
        <div class="text">{{codeInfo.initTime?parseTime(codeInfo.initTime,'{y}-{m}-{d}'):''}}</div>
      </div>
      <div class="info-item" v-if="codeInfo.endTime">
        <div class="title">质保截至：</div>
        <div class="text">{{codeInfo.endTime?parseTime(codeInfo.endTime,'{y}-{m}-{d}'):''}}</div>
      </div>
      <div class="info-item">
        <div class="title">门店安装人员：</div>
        <div class="text">{{codeInfo.workshopPerson}}</div>
      </div>
      <div class="info-item">
        <div class="title">博世出库时间：</div>
        <div class="text">{{codeInfo.deliveryDate?parseTime(codeInfo.deliveryDate,'{y}-{m}-{d}'):''}}</div>
      </div>
    </div>

    <div v-if="(codeInfo.warrantyStatus===4)&&codeInfo.warrantyHistory">
      <div class="info">
        <div class="info-item">
          <div class="title">当前里程数：</div>
          <div class="text">{{codeInfo.warrantyHistory[0].reportMileage || ''}}&nbsp;KM</div>
        </div>
        <div class="info-item">
          <div class="title">故障描述及判断：</div>
        </div>
        <div class="info-item">
          <div>{{codeInfo.warrantyHistory[0].warrantyDesc || ''}}</div>
        </div>
        <div class="info-item">
          <div class="title">照片/视频：</div>
        </div>
        <div class="info-item img-list">
          <div v-for="(item,index) of codeInfo.warrantyHistory[0].mediaList" :key="item.mediaId+index">
            <img v-if="getUrlType(item.imageUrl)==='image'" @click="showImg(item.imageUrl,'image')" :src="item.imageUrl">
            <img v-if="getUrlType(item.imageUrl)==='video'" @click="showImg(item.imageUrl,'video')" src="https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/warranty/replacement.png">
            <!-- <video autoplay class="video" v-if="getUrlType(item.imageUrl)==='video'" :src="item.imageUrl"  @click="showImg(item.imageUrl,'video')"></video> -->
          </div>
        </div>
        <div class="info-item" v-if="codeInfo.verifySign ==='02' && codeInfo.boschVerifyStatus">
          <div class="title">博世审批状态：
          </div>
          <span v-if="codeInfo.boschVerifyStatus == '01'">待审批</span>
            <span v-if="codeInfo.boschVerifyStatus == '02'">审批已通过</span>
            <span v-if="codeInfo.boschVerifyStatus == '03'">审批已拒绝</span>
        </div>
        <div class="info-item" v-if="codeInfo.verifySign ==='02' && codeInfo.boschVerifyStatus">
          <div class="title">博世审批原因：
          </div>
        <div v-if="codeInfo.boschVerifyDesc !== ''">{{ codeInfo.boschVerifyDesc }}</div>
        </div>
      </div>
      <div v-if="codeInfo.verifySign==='01'">
        <div class="input-title">审批备注:</div>
        <div class="input-textarea" style="padding: 0 10px 10px 10px;">
          <van-field
            v-model="verifyRemark"
            type="textarea"
            placeholder="请输入审批备注"
            autosize
            clearable
            maxlength="100"
            show-word-limit
          ></van-field>
        </div>
      </div>

      <div class="block-2"></div>

      <div class="footer" v-if="codeInfo.verifySign==='01'">
        <div class="btn submit-btn" @click="qaVerify('02')">通过</div>
        <div class="btn submit-btn" @click="qaVerify('04')">驳回</div>
        <div class="btn submit-btn" @click="qaVerify('03')">拒绝</div>
      </div>
    </div>

    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" >
        <div class="img-block">
          <!-- <div  v-if="urlType==='image'" :style="'background-image: url('+url+');'" class="block-img">
          </div> -->
          <img v-if="urlType==='image'"   :src="url">
          <video autoplay class="video" v-if="urlType==='video'" :src="url" controls></video>
        </div>
          <img v-if="urlType==='video'"
            @click="show=false"
            class="video-delete"
            src="../../../assets/images/activity/form-verification-off.png"
          >
      </div>

    </van-overlay>

  </div>

</div>

</template>

<script>
import Header from '../../../components/header.vue'
import { Dialog } from 'vant'
import { commonUtils } from '@/utils/common'
import activityApi from '@/api/activity'
export default {
  components: { Header },
  data () {
    return {
      value: '',
      code: '',
      codeInfo: {},
      warrantyId: '',
      data: {
        reportMileage: '',
        warrantyDesc: '',
        mediaFileIds: ''
      },
      fileList: [],
      fileId: [],
      fileUri: [],
      success: false,
      show: false,
      url: '',
      urlType: '',
      videourl: '',
      allInfoList: [],
      loading: false,
      isUploading: false,
      imgList: [],
      isReplace: '',
      deliveryDate: '',
      verifyRemark: ''
    }
  },
  watch: {
    'allInfoList' () {
      this.imgList = []
      for (let item of this.allInfoList) {
        let data = {
          type: item.type,
          name: item.originalName,
          url: item.type === 'video' ? 'https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/warranty/replacement.png' : commonUtils.getImageUrl(item.fileUri) // 'https://img.bosch-extra.com.cn:8443/public-tmp/8A/e11fc31e-2496-45f3-ad7d-9e415c953a3d.jpg' // 'https://img.bosch-extra.com.cn:8443/' + item.fileList
        }
        this.imgList.push(data)
        console.log(this.imgList)
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    parseTime: commonUtils.parseTime,
    init () {
      this.warrantyId = this.$route.query.warrantyId
      let params = {
        warrantyId: this.warrantyId
      }
      activityApi.getQaFeedbackInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          this.codeInfo = res.data.resultData.warrantyInfo
        }
      })
    },
    getItemStatus (status) {
      switch (status) {
        case 1:
          return '销售方激活'
        case 2:
          return '车主未领取'
        case 3:
          return '车主已领取'
        case 4:
          return '质保已提交'
        case 5:
          return '已失效'
        case 6:
          return '已换货'
        default:
          break
      }
    },
    gotoweb () {
      let data = JSON.stringify(this.codeInfo)
      sessionStorage.setItem('codeInfo', data)
      this.$router.push({ name: 'quality-assurance-ws-info' })
    },
    getUrlType (url) {
      let data = url.split('.')
      let imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      let videolist = ['mp4', 'm2v', 'mkv']
      let type = data[data.length - 1]
      if (imglist.indexOf(type) !== -1) {
        return 'image'
      } else if (videolist.indexOf(type) !== -1) {
        return 'video'
      }
    },
    showImg (url, type) {
      this.url = url
      this.urlType = type
      this.show = true
    },
    getUrl (uri) {
      return commonUtils.getImageUrl(uri)
    },
    handleclicksc (file) {
      let name = file.name
      for (let item of this.allInfoList) {
        if (item.type === 'video' && item.originalName === name) {
          this.url = this.getUrl(item.fileUri)
          this.urlType = 'video'
          this.show = true
        }
        if (item.type === 'image' && item.originalName === name) {
          this.url = this.getUrl(item.fileUri)
          this.urlType = 'image'
          this.show = true
        }
      }
    },

    qaVerify (status) {
      let params = {
        warrantyId: this.codeInfo.warrantyId,
        verifyStatus: status,
        verifyRemark: this.verifyRemark
      }
      activityApi.qaWorkshopVerify(params).then(res => {
        if (res.data.resultCode === '0') {
          if (status === '02') {
            Dialog.alert({
              title: '审核成功！',
              message: '请等待博世工作人员进行审批（三个工作日内）。',
              confirmButtonText: '确定',
              confirmButtonColor: '#117281'
            }).then(() => {
            })
          } else {
            this.$dialog.alert({
              message: '审核操作成功！'
            })
          }
        }
        this.init()
      })
    },

    submitQAInfo () {
      this.isReplace = ''
    },

    // 扫码
    scanCode () {
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let scanData
          scanData = {
            partQrCode: res.resultStr
          }
          this.getLocation(scanData)
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
          console.log('fail', res)
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },

    // 获取经纬度
    getLocation (scanData) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          this.scanResult(scanData)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },

    // 扫码结果
    scanResult (value) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      value.warrantyCode = this.codeInfo.warrantyCode
      activityApi.qaReplaceScan(value).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          if (res.data.resultData.electronicWarrantyInfo) {
            console.log(res.data)
            this.$dialog.alert({
              message: '换货成功，请查看保单信息'
            }).then(() => {
              this.codeInfo = res.data.resultData.electronicWarrantyInfo
              this.isReplace = res.data.resultData.isReplace
            })
          }
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    }
  }
}
</script>

<style lang="less" scoped>
@media (max-height: 450px){
  .footer {
    position: static !important;
  }
}
.block-2{
  width: 100%;
  height: 80px;
}
.block-img{
  width: 100vw;
  height: 100vh;
  z-index: 200;
  position: absolute;
  top: 0;
  z-index: 200;
}
.container{
  position: relative;
  top: 46px;
}
.result-info{
  text-align: center;
  padding: 90px 0 20px 0;
  img{
    width: 80px;
  }
  .result-info-text{
    padding: 25px 0 5px 0;
    font-size: 16px;
  }
}
.info{
  position: relative;
  padding: 10px  0;
 // margin: 20px;
  margin: 0 5px;
  background-color: white;
  border-radius: 5px;
}
.btn{
  width: 100%;
  text-align: center;
  border-radius: 3px;
  color: white;
  background-color: rgb(17, 114, 129);
}
.submit-btn{
  margin: 10px;
  padding: 12px;
}
.footer{
  width: 100vw;
  background-color: white;
  position: fixed;
  bottom: 0px;
  display: flex;
  justify-content: space-evenly;
}
.info-item{
  display: flex;
  .title{
    min-width: 100px;
    word-break: keep-all;
    color: gray;
  }
  word-break:break-all;
}
.input-info{
  top: 10px;
  position: relative;
  padding: 10px;
 // margin: 20px;
  margin: 0 5px;
  background-color: rgb(255, 255, 255) !important;
  border-radius: 5px;
  .van-field__label{
    color: red;
  }
}
.info-item{
  margin: 15px 25px;
  display: flex;
  justify-content: space-between;
  .title{
    color: gray;
  }
}
.score-field .van-field {
  background: #f1f1f1;
  border-radius: 3px;
}
.input-textarea .van-cell{
  background: #f8f8f8;
}
.input-title{
  margin: 15px 17px;
  color: rgb(22, 22, 22);
}
.input-upload{
  margin: 0 12px;
}
.img-list{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  img{
    width: 24vw;
    height: 24vw;
    object-fit: cover;
    padding: 5px;
  }
  video{
    width: 24vw;
    height: 24vw;
    margin-right: 10px;
    padding: 5px;
  }
}

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .img-block {
    position: relative;
    img{
      z-index: 99;
      max-width: 100%;
      height: auto;
      object-fit: cover;
    }
    video{
      width: 100%;
      max-height: 100vh;
    }
  }
  .video-delete{
    width: 45px;
    position: absolute;
    top: 60px;
    left: calc(100vw - 60px);
  }
  .loading{
    height: 14px;
    display: inline-block;
  }
  .video-cover{
  width: 25vw;
  height: 25vw;
  background-color: black;
}
.cover-img{
  width: 10vw;
  height: 10vw;
  padding: 7.5vw;
  background-color: black;
}
.preview-cover{

}
</style>
